import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthGuard} from "../../../../../common/auth-guard.service";
import {TranslocoService} from "@ngneat/transloco";
import {PreviousRouteService} from "../../../../../services/previous-route.service";
import {noSpecialCharacters} from "../../../../../shared/custom-validators";
import {DefaultDeviceCatalog} from "../../../../../model/default-device-catalog";
import {DefaultDeviceCategory} from "../../../../../model/default-device-category";
import {DefaultDeviceCategoriesService} from "../../../../../services/default-device-categories.service";
import {DefaultAssetRepresentation} from "../../../../../model/default-asset-representation";
import {DefaultAssetRepresentationsService} from "../../../../../services/default-asset-representations.service";

@Component({
  selector: 'app-default-devices-form-info',
  templateUrl: './default-devices-form-info.component.html',
  styleUrls: ['./default-devices-form-info.component.scss']
})
export class DefaultDevicesFormInfoComponent implements OnInit {

  @Input() mode: 'create' | 'edit';

  @Input() defaultDeviceCatalog: DefaultDeviceCatalog;
  @Output() defaultDeviceCatalogChange = new EventEmitter<DefaultDeviceCatalog>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<string>();

  defaultDeviceCatalogForm: FormGroup;

  defaultDeviceCategories: DefaultDeviceCategory[];
  defaultAssetRepresentations: DefaultAssetRepresentation[];

  constructor(private defaultDeviceCategoriesService: DefaultDeviceCategoriesService,
              private defaultAssetRepresentationsService: DefaultAssetRepresentationsService,
              private formBuilder: FormBuilder,
              private authGuard: AuthGuard,
              private i18n: TranslocoService,
              private previousService: PreviousRouteService) {
  }

  ngOnInit(): void {
    this.loadAndCreateForm();
  }

  private loadAndCreateForm(): void {
    const deviceCategoriesPromise = this.defaultDeviceCategoriesService.getDefaultDeviceCategories().toPromise().then(response => {
      this.defaultDeviceCategories = response.defaultDeviceCategories
        .sort((a, b) => a.name > b.name ? 1 : -1);
    });
    const assetRepresentationsPromise = this.defaultAssetRepresentationsService.getDefaultAssetRepresentations().toPromise().then(response => {
      this.defaultAssetRepresentations = response.defaultAssetRepresentations
        .sort((a, b) => a.name > b.name ? 1 : -1);
    });
    Promise.all([deviceCategoriesPromise, assetRepresentationsPromise]).then(values => {
      this.createForm(this.defaultDeviceCatalog);
    });
  }

  private createForm(defaultDeviceCatalog: DefaultDeviceCatalog): void {
    this.defaultDeviceCatalogForm = this.formBuilder.group({
      name: [defaultDeviceCatalog.name, [Validators.required, Validators.maxLength(255), noSpecialCharacters]],
      description: [defaultDeviceCatalog.description, [Validators.maxLength(255)]],
      version: [defaultDeviceCatalog.version, [Validators.required, Validators.maxLength(255)]],
      defaultDeviceCategory: [defaultDeviceCatalog.defaultDeviceCategory, [Validators.required]],
      defaultAssetRepresentation: [defaultDeviceCatalog.defaultAssetRepresentation, [Validators.required]],
      active: [(this.mode === 'edit') ? defaultDeviceCatalog.active : true, []],
      uuid: [defaultDeviceCatalog.uuid]
    });
    this.defaultDeviceCatalogForm.markAsPending();
  }

  onNextStep(): void {
    if (this.defaultDeviceCatalogForm.valid) {
      this.nextStep.emit();
      this.defaultDeviceCatalogChange.emit(this.defaultDeviceCatalogForm.getRawValue());
    }
  }

  onCancel(): void {
    this.cancel.emit(this.previousService.getPreviousUrl());
  }

}
